import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const FAQS = [
  { question: "What happens when I exceed my search limit?", answer: "Free users will need to wait until the next day for more searches. Upgrade to Premium Economy Pack or First Class Pack for unlimited searches." },
  { question: "Can I cancel my subscription at any time?", answer: "Yes, you can cancel anytime. Your access continues until the end of your billing cycle." },
  { question: "What's the difference between Boost Passes and subscriptions?", answer: "Boost Passes are perfect for short trips with temporary access. Subscriptions are ideal for regular travelers." },
  { question: "Can I upgrade or downgrade my plan?", answer: "Yes, you can change your plan anytime. Upgrades take effect immediately." },
  { question: "What payment methods do you accept?", answer: "We accept all major credit and debit cards through Stripe. All transactions are secure and encrypted." },
  { question: "Can I gift a subscription to someone?", answer: "Yes! You can purchase gift subscriptions for any plan and duration. The recipient will receive an email with instructions to activate their gift." },
];

export const PricingFAQ = () => (
  <section id="pricing-faq" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 scroll-mt-24" aria-labelledby="faq-heading">
    <p className="text-sm font-semibold uppercase tracking-wide text-primary">The details</p>
    <h2 id="faq-heading" className="mt-5 mb-10 text-4xl sm:text-5xl font-bold tracking-tight text-foreground">Before you choose.</h2>
    <div className="max-w-3xl">
      <Accordion type="single" collapsible className="border-t border-border">
        {FAQS.map((faq, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-b border-border">
            <AccordionTrigger className="py-6 text-left text-base sm:text-lg font-semibold text-foreground hover:no-underline">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="pb-6 max-w-2xl text-base leading-relaxed text-muted-foreground">{faq.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
